module.exports = __webpack_public_path__ + "75ee90ff002526252f5799ae81d67347.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/whiskers-beak.png
// module id = 1834
// module chunks = 0